import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useSelector } from "react-redux";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import { Commas } from "../../../../Common/AllDateTimeReleventFormate";
import YourPost from "../../../../Common/Label/YourPost";
import PostReportMenu from "../../../../Common/Label/PostReportMenu";
import { navigateToNextTab } from "../../../../Common/FewCommonMethods";
import ImageWithFallback from "../../../../../common/ImageWithFallback";
import CommonPagination from "../../../../Common/PaginationComponet/CommonPagination";
import { useAllFilterBaseContext } from "../../../../../Context/AllFilterBaseContext";

export default function AllBuyProducts({ activeTab }) {
  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const { state, setPageNumber } = useAllFilterBaseContext();

  const getallsale = useSelector(
    ({ sale: { getfilterdsale } }) => getfilterdsale
  );
  const getsalelist = getallsale?.response || [];

  return (
    <div className="col-lg-9 col-md-8 filter-right">
      <h2>All Products</h2>
      {Array.isArray(getsalelist) && getsalelist.length > 0 ? (
        <div className="row packaged-row">
          {Array.isArray(getsalelist) &&
            getsalelist?.map((item, index) => (
              <div className="col-lg-4 col-md-6 col-6" key={index}>
                <div className="d-flex post-sold">
                  <YourPost item={item} />
                  {(item?.status == 2 || item?.status == 3) && (
                    <p
                      className="post-applied  post-ap your-postbtn"
                      style={{ background: "#DE311ECC" }}
                    >
                      Sold out
                    </p>
                  )}
                </div>
                <div
                  className={
                    item?.status == 2 || item?.status == 3
                      ? "packaged-img soldout"
                      : "packaged-img"
                  }
                  style={{ position: "relative" }}
                  onClick={
                    () => navigateToNextTab(`productdetails/${item?.id}`)
                    // navigate(`/${lan}/productdetails/${item?.id}`)
                  }
                >
                  <PostReportMenu item={item} masterType={3} />
                  {Array.isArray(item?.files) && item?.files[0] ? (
                    <div className="w-100">
                      <ImageWithFallback url={item?.files[0]?.file} className="w-100" />
                    </div>
                  ) : (
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/homepage/bxp-1.png`}
                      className="w-100"
                      alt=""
                    />
                  )}
                  <h6>{item?.title}</h6>
                  <h3>SAR {Commas(item?.price)}</h3>
                </div>
              </div>
            ))}
          {getallsale && (
            <CommonPagination
              totalitemcounts={
                activeTab == "allpost"
                  ? getallsale?.count?.count
                  : activeTab == "recentview"
                    ? getallsale?.count?.viewed_count
                    : activeTab == "savepost"
                      ? getallsale?.count?.wishlist_count
                      : getallsale?.count?.count
              }
              size={15}
              pageNumber={state?.pageNumber}
              setPageNumber={setPageNumber}
            />
          )}
        </div>
      ) : (
        <PostNotFound title={"Products Not Found..."} />
      )}
    </div>
  );
}
